import { render, staticRenderFns } from "./ListadoFarmacias.vue?vue&type=template&id=6aaa1aa0"
import script from "./ListadoFarmacias.vue?vue&type=script&lang=js"
export * from "./ListadoFarmacias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports